import { FC, lazy, Suspense } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Loading from '@/components/skeleton';

import Analytics from '@/components/analytics';

const Checkout = lazy(() => import('./checkout'));
const PreviewInvoice = lazy(() => import('./checkout/preview'));
const PreviewPayByLink = lazy(() => import('./paybylinkV2/preview'));
const CheckoutSuccess = lazy(() => import('./paymentSuccess'));
const InvoiceError = lazy(() => import('./error/invoiceError'));
const PaymentLinkError = lazy(() => import('./error/paymentLinkError'));
const PaymentLinkErrorV2 = lazy(() => import('./error/paymentLinkErrorV2'));
const PayByLinkPrePayment = lazy(() => import('./paybylink/prePayment'));
const PayByLinkPayment = lazy(() => import('./paybylink/payment'));
const PayByLinkPaymentV2 = lazy(() => import('./paybylinkV2/prePayment'));
const PayByLinkPaymentSuccess = lazy(() => import('./paybylink/success'));
const SuccessV2 = lazy(() => import('./paybylinkV2/Success/index'));

const Index: FC<{ enableV2: boolean }> = ({ enableV2 }) => {
  return (
    <BrowserRouter>
      <Analytics />
      <Suspense fallback={<Loading />}>
        <Switch>
          {/* Theme WebApp iframe previews (RFC-252). Must be first so the
              explicit paths match before `/:code` or `/pay/:region/...` patterns. */}
          <Route path="/pay/preview/xero" exact component={PreviewInvoice} />
          <Route path="/pay/preview/paybylink" exact component={PreviewPayByLink} />
          {/* short payment link url */}
          <Route path="/:code" exact component={enableV2 ? PayByLinkPaymentV2 : PayByLinkPrePayment} />
          {/* original payment link url */}
          <Route path="/pay/link/preview" exact component={enableV2 ? PayByLinkPaymentV2 : PayByLinkPrePayment} />
          <Route
            path="/pay/:region/link/payment/success"
            exact
            component={enableV2 ? SuccessV2 : PayByLinkPaymentSuccess}
          />
          <Route
            path="/pay/:region/link/payment/error"
            exact
            component={enableV2 ? PaymentLinkErrorV2 : PaymentLinkError}
          />
          <Route path="/pay/:region/link/payment/:intentId" exact component={PayByLinkPayment} />
          <Route path="/pay/:region/link/:code" exact component={enableV2 ? PayByLinkPaymentV2 : PayByLinkPrePayment} />
          <Route path="/pay/:region/invoice/success" exact component={CheckoutSuccess} />
          <Route path="/pay/:region/invoice/error" exact component={InvoiceError} />
          <Route path="/pay/:region/invoice/:platform" exact component={Checkout} />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
};

export default Index;
